export const RENT_HOUSE = {
  nickname: 'PRODUCTS.RENT_HOUSE.shortname',
  isHidden: true,
  icon:'rent-house'
};
